import { MultiPartProgressbarType } from "./MultiPartProgressbar.types";
import { ProgressbarPart } from "./ProgressbarPart";
import { ProgressbarContainer } from "./MultiPartProgressbar.styles";

export function MultiPartProgressbar({ parts }: MultiPartProgressbarType) {
    return (
        <ProgressbarContainer>
            {parts.map((part, index) => {
                if (!part.value) {
                    return null;
                }
                return (
                    <ProgressbarPart key={`${index}-${part.value}`} {...part} />
                );
            })}
        </ProgressbarContainer>
    );
}
